import React from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";
import { validateForm } from "utils/validation";
import { ContactInformationRules } from "validation/ValidationRules";
import { Create } from "adminApi/ContactInformation/ContactInformation";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import fields from "../json/ContactInformationFields.json";
import AddContactInformationForm from "./Componates/AddContactInformationForm";

const AddContactInformation = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize empty values from JSON
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  // Form change handler hook
  const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(initialValues, ContactInformationRules);

  // Submit handler hook
  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await Create({ data: formValues });
    },
    (vals) => {
      const err = validateForm(vals, ContactInformationRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Contact information added successfully"
  );

  return (
    <>
      {loading && <Spinner isSpinner={true} />}
      <AddContactInformationForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loading}
        imagePreview={values.imagePreview || values.image}
      />
    </>
  );
};

export default AddContactInformation;
